// Centralized article data sourced from PDFs provided by Dra. Melissa Núñez Robles.
// Sections support: { type: 'paragraph' | 'heading' | 'list', text?, items? }

export const articles = [
  {
    id: 1,
    slug: 'estimulando-el-cerebro-regreso-a-clases',
    title: 'Estimulando el cerebro desde la perspectiva cognitiva para el regreso a clases',
    author: 'Dra. Melissa Núñez Robles',
    authorBio: 'Fundadora y Directora de Rise & Shine Learning Zone.',
    date: '25 de agosto de 2023',
    dateShort: 'Agosto 2023',
    image: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/7uzekd7m_80270f20-5a2f-4ef8-94e8-24438a3923b5.jpeg',
    summary: 'La estimulación cognitiva es clave en el desarrollo académico y emocional de los niños, especialmente durante el regreso a clases. Este artículo explora cómo apoyar procesos como la memoria, atención, lenguaje y funciones ejecutivas mediante estrategias prácticas que los padres pueden implementar.',
    metaDescription: 'Descubre cómo la estimulación cognitiva apoya el desarrollo académico y emocional de los niños durante el regreso a clases. Estrategias prácticas por la Dra. Melissa Núñez Robles.',
    sections: [
      {
        type: 'paragraph',
        text: 'De cara al inicio de un nuevo año escolar es de suma importancia conocer los beneficios de la estimulación cognitiva en el desarrollo académico y emocional de los niños. El comienzo de un nuevo año en ocasiones puede representar un conjunto de emociones en el cerebro. La ansiedad, el miedo y la inseguridad, pueden formar parte del proceso ante la llegada de un nuevo reto. El regreso a clases trae consigo nuevas amistades, nuevos círculos sociales y sobre todo el enfrentarse a retos académicos, luego de dos años atípicos afectados por los temblores y la pandemia. Estas situaciones llevaron a nuestros niños a un encierro inesperado en el cual la tecnología y los dispositivos fueron los grandes protagonistas en el proceso educativo. No obstante, existen estrategias que pueden ser utilizadas por padres y maestros para aminorar las emociones que puedan dificultar el proceso de aprendizaje y adaptación.'
      },
      {
        type: 'paragraph',
        text: 'Según los autores Ordoñez & Tinajero (2005), la estimulación cognitiva es un conjunto de actividades dirigidas a mantener o a perfeccionar el funcionamiento cognitivo en general, a través de ejercicios de memoria, percepción, atención, concentración, lenguaje, funciones ejecutivas como: solución de problemas, planificación, razonamiento y control. Si se estimulan estos procesos cognitivos, el pequeño amplía su vocabulario, ve fomentada su expresión verbal y mejora su comprensión lectora. Con estas actividades, el niño pone en marcha su pensamiento sin encontrar ningún límite. Esto consigue que el pequeño le dé alas a su imaginación y explore pensamientos nuevos.'
      },
      {
        type: 'paragraph',
        text: 'Mejora la confianza, la autoestima y la seguridad del niño, ya que el pequeño va logrando objetivos y se siente capaz de superar problemas o situaciones en su diario vivir.'
      },
      {
        type: 'paragraph',
        text: 'Finalmente, los ejercicios de memoria, juegos de asociación, juegos para estimular el lenguaje, adivinanzas y buscar diferencias en imágenes similares, pueden formar parte de una guía pedagógica para realizar las actividades de la forma correcta según las necesidades del pequeño.'
      },
      {
        type: 'paragraph',
        text: 'Aunque en este artículo nos hemos centrado en la estimulación cognitiva en niños, estos procesos son aplicables a cualquier edad. Por tanto, estimular el cerebro mediante intervención temprana desde la etapa de infantes y a lo largo de su vida, será beneficioso en el desempeño académico y social del menor.'
      }
    ]
  },
  {
    id: 2,
    slug: 'terapia-educativa-clinica',
    title: 'Terapia Educativa Clínica: información importante',
    author: 'Dra. Melissa Núñez Robles',
    authorBio: 'Fundadora y Directora de Rise & Shine Learning Zone.',
    date: 'Septiembre de 2024',
    dateShort: 'Septiembre 2024',
    image: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/l9vink7f_203fbbdc-c0d4-49e2-aeef-03bfbd534f6c.jpeg',
    summary: 'La Terapia Educativa Clínica (TEC) ofrece apoyo psicoeducativo a niños, adolescentes y adultos con dificultades para aprender de manera tradicional. Conoce qué es, qué servicios incluye y cómo el entrenamiento cerebral fortalece las funciones ejecutivas.',
    metaDescription: 'Información sobre Terapia Educativa Clínica (TEC) en Rise & Shine Learning Zone: evaluación, diagnóstico y tratamiento psicoeducativo enfocado en estimulación cognitiva.',
    sections: [
      {
        type: 'heading',
        text: '¿Qué es la Terapia Educativa Clínica?'
      },
      {
        type: 'paragraph',
        text: 'La Terapia Educativa (TEC) se ofrece por un grupo de terapeutas altamente cualificados en la psicoeducación que trabajan con niños, adolescentes y adultos que tienen problemas para aprender de la manera tradicional.'
      },
      {
        type: 'paragraph',
        text: 'El terapeuta educativo posee una formación especializada que le permite identificar y apoyar muchos de los trastornos de aprendizaje más comunes que afectan a las personas que tienen dificultades para aprender.'
      },
      {
        type: 'paragraph',
        text: 'Los terapeutas educativos pueden diagnosticar y tratar a estos pacientes utilizando criterios de enseñanza psicoeducativos y funcionales que brindan a las personas que han sido diagnosticadas con discapacidades de aprendizaje, la oportunidad de corregir o superar sus necesidades cognitivas.'
      },
      {
        type: 'heading',
        text: 'Servicios'
      },
      {
        type: 'list',
        items: ['Evaluación', 'Diagnóstico', 'Terapia']
      },
      {
        type: 'heading',
        text: 'Ofrecemos apoyo en las siguientes áreas'
      },
      {
        type: 'list',
        items: [
          'Lectoescritura',
          'Lectura y comprensión',
          'Análisis',
          'Pensamiento crítico',
          'Intervención individualizada'
        ]
      },
      {
        type: 'heading',
        text: '¿Qué es nuestro programa de refuerzo educativo con enfoque terapéutico?'
      },
      {
        type: 'paragraph',
        text: 'Es un proyecto con amor para reforzar el aprendizaje a través de juegos y actividades sensoriales, explorando con los sentidos para fortalecer el desarrollo físico, cognitivo y emocional en niños. Mediante este programa, el niño(a) realizará actividades de entrenamiento cerebral que le ayudarán a superar sus necesidades cognitivas.'
      },
      {
        type: 'heading',
        text: 'Nuestro enfoque terapéutico va dirigido a trabajar con las funciones ejecutivas'
      },
      {
        type: 'paragraph',
        text: 'Las funciones ejecutivas se desarrollan desde la infancia hasta pasados los veinte años de edad. Son un grupo de habilidades mentales que usamos todos los días para aprender y trabajar en nuestra vida diaria. Problemas del funcionamiento ejecutivo pueden generar dificultad para concentrarse, seguir instrucciones y manejar las emociones, entre otras conductas.'
      },
      {
        type: 'heading',
        text: 'Intervenciones intensivas'
      },
      {
        type: 'paragraph',
        text: 'Lectura y comprensión lectora, escritura, ortografía, sintaxis, cálculos matemáticos, atención, memoria, concentración, procesamiento sensorial, vida independiente, toma de decisiones, autogestión, emociones, manejo de dificultades, formación social, desarrollo prelaboral, planificación y preparación de presupuesto personal, entre otras.'
      },
      {
        type: 'heading',
        text: '¿Quiénes somos?'
      },
      {
        type: 'paragraph',
        text: 'Rise & Shine Learning Zone es un colegio licenciado por el Departamento de Estado, cuya directora posee registro para ofrecer Terapia Educativa Clínica (TEC), ubicado en el Municipio de Dorado. Ofrecemos tratamiento psicoeducativo enfocado en la estimulación cognitiva. El entrenamiento cerebral sirve para estimular las principales capacidades cognitivas (atención, memoria, lenguaje, funciones ejecutivas, funciones visoespaciales, percepción, etc.), el cual tiene como finalidad la mejora y el mantenimiento de las funciones cerebrales. El cerebro, cuando no se estimula, al igual que todo nuestro cuerpo, tiende a debilitarse.'
      },
      {
        type: 'heading',
        text: 'Nuestra misión'
      },
      {
        type: 'paragraph',
        text: 'Proveer apoyo psicoeducativo integral dirigido a brindarle al paciente la capacidad de maximizar el aprendizaje mediante entrenamiento cerebral. Nuestro esfuerzo va dirigido a desarrollar estrategias de intervención efectivas que puedan enriquecer la experiencia educativa y superar las necesidades cognitivas de nuestros pacientes.'
      },
      {
        type: 'heading',
        text: 'Nuestra visión'
      },
      {
        type: 'paragraph',
        text: 'Ofrecer servicios de excelencia y calidad que ayuden al paciente a expandir de manera integral su conocimiento, enfatizando la seguridad en sí mismos y fomentando los valores que le permitan empoderarse de las situaciones y transformarlas en oportunidades de aprovechamiento.'
      }
    ]
  }
];

export const getArticleBySlug = (slug) => articles.find((a) => a.slug === slug);
